import classes from "./NavBar.module.css";
import { Link } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";

function NavBar() {
  const [width, setWindowWidth] = useState(0);
  // this deletes text on certain width
  useEffect(() => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);
  const updateDimensions = () => {
    const width = window.innerWidth;
    setWindowWidth(width);
  };

  // Trying to keep underline on current page.
  const onLinkClick = () => {
    const navBar = document.querySelector(`.${classes.list}`);
    navBar.classList.toggle(classes.active);
  };

  return (
 <>
   { width > 450 && <nav className={classes.navbar} >
        <ul>
          <li className={classes.list}>
            <Link className={classes.link} to="/">
              Home
            </Link>
          </li>
          <li>
            <Link className={classes.link} to="/about">
              About
            </Link>
          </li>
          <li>
            <Link className={classes.link} to="/skills">
              Skills
            </Link>
          </li>
          <li>
            <Link className={classes.link} to="/projects">
              Projects
            </Link>
          </li>
          <li>
            <Link className={classes.link} to="/contact">
              Contact
            </Link>
          </li>
        </ul>
      </nav>}
 </>
  );
}

export default NavBar;
